import axios from 'axios'
import { currentCurrency } from '@/composables/currency'
import { currentLang } from '@/locales/lang'

function getCookie(name) {
  const value = `; ${document.cookie}`
  const parts = value.split(`; ${name}=`)
  if (parts.length === 2) return parts.pop().split(';').shift()
  return null
}

axios.defaults.withCredentials = true

axios.interceptors.request.use(config => {
  config.headers['Accept-Language'] = currentLang.value
  config.headers['X-Currency'] = currentCurrency.value
  const csrfToken = getCookie('csrftoken')
  if (csrfToken) config.headers['X-CSRFToken'] = csrfToken
  return config
})

export default axios
